import { StateToken } from '@ngxs/store';
import { User, UserSettings } from '../../../models/user.models';

export interface UserStateModel {
  details?: User;
  settings?: UserSettings;
}

export const USER_STATE_TOKEN = new StateToken<UserStateModel>('user');
